import { useHttpClient } from '@/api/httpClient.js';

const resource = 'board';

export function fetchSortitionResult({ sortitionId, apiToken }) {
	const headers = apiToken
		? {
				'X-API-Token': apiToken
		  }
		: {};

	return useHttpClient('v2').get(`/${resource}/result`, {
		headers,
		params: {
			sortitionId: sortitionId,
			apiToken: apiToken
		}
	});
}

export function fetchGeneralParams(apiToken) {
	const headers = apiToken
		? {
				'X-API-Token': apiToken
		  }
		: {};

	return useHttpClient('v2').get(`/${resource}/general_params`, {
		headers
	});
}
